module.exports = __webpack_public_path__ + "static/baba-lysaga-mtg_clsjpg-8761b83cd4ae8e6c389c66661c100938.jpg";